export default __webpack_public_path__ + "static/media/project3.c54d90ee.webp";